(function () {
  'use strict';

  var COOKIE_NAME = 'vegenergy_shop_market';
  var root = document.documentElement;
  var gate = document.getElementById('VegenergyMarketGate');

  if (window.Shopify && window.Shopify.designMode) {
    root.classList.add('shopify-design-mode');
    root.classList.remove('veg-market-gate-pending');
    return;
  }

  if (!gate || !root.classList.contains('veg-market-gate-pending')) return;

  var buttons = gate.querySelectorAll('[data-veg-market-choice]');
  var forms = gate.querySelectorAll('form');
  var firstButton = buttons.length ? buttons[0] : null;

  function rememberMarket(value) {
    var maxAge = 180 * 24 * 60 * 60;
    document.cookie =
      COOKIE_NAME + '=' + encodeURIComponent(value) +
      '; Path=/; Max-Age=' + maxAge + '; SameSite=Lax; Secure';
  }

  function chooseMarket(event) {
    var button = event.submitter || event.currentTarget.querySelector('[data-veg-market-choice]');
    if (!button) return;
    var market = button.getAttribute('data-veg-market-choice');

    if (market !== 'AT' && market !== 'DE') return;

    rememberMarket(market);
    gate.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-pressed', 'true');

    try {
      window.dispatchEvent(new CustomEvent('vegenergy:market-selected', {
        detail: { market: market }
      }));
    } catch (_) {}

    // Erst im nächsten Task sperren, damit der aktuelle Submit garantiert
    // an Shopifys Localization-Endpunkt gesendet wird.
    window.setTimeout(function () {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true;
      }
    }, 0);
  }

  for (var i = 0; i < forms.length; i++) {
    forms[i].addEventListener('submit', chooseMarket);
  }

  gate.setAttribute('aria-hidden', 'false');
  requestAnimationFrame(function () {
    if (firstButton) firstButton.focus({ preventScroll: true });
  });
})();
